document.addEventListener('DOMContentLoaded', function () {

  // Activar animaciones solo cuando JS carga correctamente
  document.body.classList.add('js-loaded');

  // Cursor (solo desktop con mouse)
  if (window.matchMedia('(pointer: fine)').matches) {
    const cur = document.getElementById('cur'), curR = document.getElementById('curR');
    if (cur && curR) {
      let mx=0,my=0,rx=0,ry=0;
      document.addEventListener('mousemove', e => {
        mx=e.clientX; my=e.clientY;
        cur.style.left=mx-4+'px'; cur.style.top=my-4+'px';
      });
      (function loop(){
        rx+=(mx-rx)*.1; ry+=(my-ry)*.1;
        curR.style.left=rx-16+'px'; curR.style.top=ry-16+'px';
        requestAnimationFrame(loop);
      })();
      document.querySelectorAll('a,button,.caso-card,.serv-item,.cli-card,.cap-tag,.mani-stat').forEach(el=>{
        el.addEventListener('mouseenter',()=>{ cur.style.transform='scale(3)'; curR.style.transform='scale(1.5)'; curR.style.opacity='.4'; });
        el.addEventListener('mouseleave',()=>{ cur.style.transform='scale(1)'; curR.style.transform='scale(1)'; curR.style.opacity='1'; });
      });
    }
  }

  // Nav scroll
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => { nav.classList.toggle('scrolled', window.scrollY > 60); });
  }

  // Burger / Dropdown
  const burger = document.getElementById('burger');
  const dropdown = document.getElementById('dropdown');
  if (burger && dropdown) {
    burger.addEventListener('click', () => {
      const open = burger.classList.toggle('open');
      dropdown.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      dropdown.setAttribute('aria-hidden', !open);
    });
    document.querySelectorAll('.dd-link').forEach(link => {
      link.addEventListener('click', () => {
        burger.classList.remove('open');
        dropdown.classList.remove('open');
        burger.setAttribute('aria-expanded', false);
      });
    });
    window.addEventListener('scroll', () => {
      if (dropdown.classList.contains('open')) {
        burger.classList.remove('open');
        dropdown.classList.remove('open');
      }
    }, { passive: true });
  }

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('v'), i * 80);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('v'));
  }

});
